import AddCustomNdaCard from './AddCustomNdaCard.component';

export default AddCustomNdaCard;